import { createContext } from 'react';
import { Client, Practice, User } from './api/generated';

export const UserContext = createContext<{ user?: User, activeClient?: Client, clients?: Client[], isLoading: boolean, practices?: Practice[], activePractice?: Practice }>({ isLoading: false });
